import { createContext, FC, useCallback, useState } from 'react'
import { useImmer } from 'use-immer'

import user from '@service/user'

import type { IProfileContext } from '@base/@types/providers/Shared/ProfileProvider'

const ProfileProvider: FC = ({ children }) => {
  const [loading, setLoading] = useState(false)
  const [profileQuery, setProfileQuery] = useState('')

  const [profiles, updateProfiles] = useImmer([])
  const [users, updateUser] = useImmer([])

  const getUsers = useCallback(async () => {
    try {
      const { data: userData } = await user.getAll()
      updateUser((draft: any) => {
        draft.splice(0, draft.length, ...userData.data)
      })
    } catch (error) {}
  }, [updateUser])

  const getProfiles = useCallback(async () => {
    setLoading(true)
    try {
      // Buscar perfis
      const { data: profileData } = await user.getAllProfiles()
      updateProfiles((draft: any) => {
        draft.splice(0, draft.length, ...profileData.data)
      })

      // Buscar usuários
      await getUsers()
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }, [updateProfiles, getUsers])

  return (
    <ProfilesContext.Provider
      value={{
        loading,

        profileQuery,
        setProfileQuery,

        profiles,
        users,
        getProfiles,
        getUsers
      }}
    >
      {children}
    </ProfilesContext.Provider>
  )
}

export default ProfileProvider

export const ProfilesContext = createContext<IProfileContext>(
  {} as IProfileContext
)
